import { render } from "./PartnerSingle.vue?vue&type=template&id=49b9c716&scoped=true"
import script from "./PartnerSingle.vue?vue&type=script&lang=js"
export * from "./PartnerSingle.vue?vue&type=script&lang=js"

import "./PartnerSingle.vue?vue&type=style&index=0&id=49b9c716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b9c716"]])

export default __exports__